module.exports = __webpack_public_path__ + "img/Thank-you-demo-banner-v2.2.1ab3141d.png";